import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchResearchContent } from "../APIClient/apiClient";

// Research content hook
export function useResearchContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState({
    title: "",
    description: "",
    researchs: [],
    headerTexts: [],
    metaTitle: "",
  });

  useEffect(() => {
    let isActive = true;

    setContent({
      title: "",
      description: "",
      researchs: [],
      headerTexts: [],
      metaTitle: "",
    });

    fetchResearchContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setContent({
          title: data.title || "",
          description: data.description || "",
          researchs: Array.isArray(data.researchs) ? data.researchs : [],
          headerTexts: Array.isArray(data.headerTexts) ? data.headerTexts : [],
          metaTitle: data.metaTitle || "",
        });
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return content;
}
